// Lokalni pamet postupu nascriptovaneho tutorial souboje (viz
// docs/superpowers/specs/2026-08-16-tutorial-oak-fight-design.md, sekce B) -
// scoped na trainer.id, protoze localStorage je sdileny napric ucty ve
// stejnem prohlizeci (testovaci ucet). Stejna konvence jako `pr.flags`
// ve featureFlags.js (JSON blob v jednom klici).
const STORAGE_KEY = 'pr.tutorialFightStep';

function readAll() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
        return {};
    }
}

export function getTutorialFightStep(trainerId) {
    return readAll()[trainerId] || null;
}

export function setTutorialFightStep(trainerId, step) {
    const all = readAll();
    all[trainerId] = step;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function clearTutorialFightStep(trainerId) {
    const all = readAll();
    delete all[trainerId];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}
